import LayoutBanners from '../services/layout-banners';
export default (topBannersContainer, rightSideBannersContainer) => {
    if (topBannersContainer) {
        const topBanners = topBannersContainer.querySelectorAll('.layout-banner');
        topBanners.forEach((banner) => {
            const dataSet = banner.dataset;
            const bannerId = dataSet.id;
            if (!bannerId) {
                return;
            }
            const closeButton = banner.querySelector('.layout-banner__close');
            if (!closeButton) {
                return;
            }
            closeButton.addEventListener('click', () => {
                LayoutBanners.close(banner);
            });
            const isClosed = LayoutBanners.isClosed(Number(bannerId));
            if (!isClosed) {
                LayoutBanners.show(banner);
            }
        });
    }
    if (rightSideBannersContainer) {
        const rightSideBanner = rightSideBannersContainer.querySelector('.layout-banner');
        if (rightSideBanner) {
            const dataSet = rightSideBanner.dataset;
            const bannerId = dataSet.id;
            const type = dataSet.type;
            const isClosed = LayoutBanners.isClosed(Number(bannerId));
            if (!isClosed) {
                rightSideBannersContainer.classList.add('open');
            }
            const handler = rightSideBanner.querySelector('.layout-banner__open-handler');
            if (handler) {
                handler.addEventListener('click', () => {
                    const isOpen = rightSideBannersContainer.classList.contains('open');
                    if (isOpen) {
                        rightSideBannersContainer.classList.remove('open');
                        LayoutBanners.closeById(Number(bannerId), Number(type));
                    }
                    else {
                        rightSideBannersContainer.classList.add('open');
                        LayoutBanners.removeFromStorage(Number(bannerId));
                    }
                });
            }
        }
    }
};
